import React from 'react'
import styled from "styled-components";

const Line = styled.div`
    position: absolute;
    right: -5%;
    width: fit-content;
    height: 100%;
    bottom: 0;

    @media (min-width: 1920px){
        right: 0;
    }

    @media (max-width: 1620px){
        display: none;
    }
`;

const Body = styled.div`
    width: 2px;
    height: 70%;
    border-right: 2px dashed #38393B;
    position: absolute;
    top: 13%;
    right: 122px;
    z-index: 9999;
`;

export const Bottom = styled.div`
    width: 2px;
    height: 15%;
    border-right: 2px dashed #38393B;
    position: absolute;
    top: 0px;
    right: 185px;
    z-index: 9999;
    transform: rotate(-45deg);
`;

export const Top = styled.div`
    width: 2px;
    height: 20%;
    border-right: 2px dashed #38393B;
    position: absolute;
    bottom: -4px;
    right: 39px;
    z-index: 9999;
    transform: rotate(-45deg);
`;

const SecondRight = () => {
    return (
        <Line>
            <Top />
            <Body />
            <Bottom />
        </Line>
    )
}

export default SecondRight
